import { get } from "./AXIOS"
import { HOME_PAGE_DASHBOARD, HOME_PAGE_DASHBOARD_PUBLIC, KEY_METRICS_HOME, } from "./CONSTANTS"
import { buildQueryParams, usePublic } from "helpers/utlities";

export const getKeyMetrics = async () => {
  try {
    return await get(KEY_METRICS_HOME)
  } catch (e) {
    console.log("Error", e)
    return e
  }
}

export const getHomePageDashboardData = async (query) => {

  const params = buildQueryParams({
    ...(query?.countryID !== 0 && { country_id: query?.countryID }),
  });

  try {
    return await get(`${usePublic() ? HOME_PAGE_DASHBOARD_PUBLIC : HOME_PAGE_DASHBOARD}?${params.toString()}`);
  } catch (e) {
    console.log("Error", e);
    return e;
  }
}